import { ReactNode, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@7shifts/sous-chef';
import { useSettings } from 'hooks/useSettings';

interface KanbanRouteGuardProps {
    children: ReactNode;
}

const KanbanRouteGuard = ({ children }: KanbanRouteGuardProps) => {
    const { isLoadingSettings, settings } = useSettings();

    const findSetting = (key: string, defaultValue: string) => {
        const setting = settings.find((s) => s.key === key);
        return setting ? setting.value : defaultValue;
    };

    const [isKanbanSettingsEnabled, setIsKanbanSettingsEnabled] =
        useState<string>();

    useEffect(() => {
        if (!isLoadingSettings) {
            const kanbanEnabled = findSetting('kanban', 'disabled');
            setIsKanbanSettingsEnabled(kanbanEnabled);
        }
    }, [isLoadingSettings]);

    if (isLoadingSettings) {
        return <Spinner block />;
    } else if (isKanbanSettingsEnabled === 'disabled') {
        return <Navigate to="/tickets" replace />;
    }

    return <>{children}</>;
};

export default KanbanRouteGuard;
